<template>
  <v-dialog
    v-model="dialog"
    persistent
    transition="dialog-bottom-transition"
    max-width="1000"
  >
    <!--begin::Modal dialog-->
    <div class="bg-white poppins">
      <!--begin::Modal header-->
      <div class="modal-header align-center">
        <h3 class="mb-0 font-weight-bolder">Confim shipping</h3>
        <!--begin::Close-->
        <div
          class="btn btn-sm btn-icon btn-active-light-info"
          @click="toggleModal"
        >
          <span class="svg-icon">
            <v-icon size="22">mdi-close</v-icon>
          </span>
        </div>
        <!--end::Close-->
      </div>
      <!--end::Modal header-->
      <!--begin::Modal body-->
      <div class="modal-body d-flex flex-column scroll-y mx-5 mx-xl-15 py-7">
        <!--begin::Body-->
        <div v-if="orderDetails.order" class="bg-secondary rounded p-6 mb-3">
          <v-row>
            <v-col cols="auto">
              <v-row class="bg-secondary rounded mt-0">
                <v-col cols="auto" class="font-weight-black py-0 pr-0">
                  Order id:
                </v-col>
                <v-col class="py-0">{{ orderDetails.order.ordersId }}</v-col>
              </v-row>
            </v-col>
            <v-col cols="auto">
              <v-row class="bg-secondary rounded">
                <v-col cols="auto" class="font-weight-black pr-0">
                  System order number:
                </v-col>
                <v-col>{{ orderDetails.order.system_order_number }}</v-col>
              </v-row>
            </v-col>
            <v-col cols="auto">
              <v-row class="bg-secondary rounded">
                <v-col cols="auto" class="font-weight-black pr-0">
                  Order delivery number:
                </v-col>
                <v-col>{{ orderDetails.order.order_delivery_number }}</v-col>
              </v-row>
            </v-col>
            <v-col cols="auto">
              <v-row class="bg-secondary rounded">
                <v-col cols="auto" class="font-weight-black pr-0">
                  Warehouse:
                </v-col>
                <v-col>{{ orderDetails.order.warehouse }}</v-col>
              </v-row>
            </v-col>
          </v-row>
        </div>
        <div v-if="orderDetails.order" class="bg-secondary rounded p-6 mb-3">
          <v-row>
            <v-col cols="auto">
              <v-row class="bg-secondary rounded mt-0">
                <v-col cols="auto" class="font-weight-black py-0 pr-0">
                  Customer:
                </v-col>
                <v-col class="py-0">{{ orderDetails.order.customer }}</v-col>
              </v-row>
            </v-col>
            <v-col cols="auto">
              <v-row class="bg-secondary rounded">
                <v-col cols="auto" class="font-weight-black pr-0">
                  Order type:
                </v-col>
                <v-col>{{ orderDetails.order.order_type }}</v-col>
              </v-row>
            </v-col>
            <v-col cols="auto">
              <v-row class="bg-secondary rounded">
                <v-col cols="auto" class="font-weight-black pr-0">
                  Comment:
                </v-col>
                <v-col>{{ orderDetails.order.comment }}</v-col>
              </v-row>
            </v-col>
            <v-col cols="auto">
              <v-row class="bg-secondary rounded">
                <v-col cols="auto" class="font-weight-black pr-0">
                  Total SKU:
                </v-col>
                <v-col>{{ orderDetails.order.total_skus }}</v-col>
              </v-row>
            </v-col>
          </v-row>
        </div>
        <div class="mt-6">
          <v-data-table
            item-key="id"
            :item-class="secondText"
            :headers="headers"
            :items="orderDetails.order_boxes"
            :items-per-page="10"
            dense
            class="elevation-1"
          ></v-data-table>
        </div>

        <!--end::Body-->

        <!--begin::Actions-->
        <div class="my-4 d-flex flex-grow-1 align-end justify-center">
          <button
            type="reset"
            class="btn btn-light mr-3 px-5 py-3 ls1"
            @click="toggleModal"
          >
            Cancel
          </button>
          <button
            type="submit"
            class="btn btn-info px-5 py-3 ls1"
            @click="confirmShipping"
          >
            Confirm
          </button>
        </div>
        <!--end::Actions-->
      </div>
      <!--end::Modal body-->
    </div>
    <!--end::Modal dialog-->
  </v-dialog>
</template>

<script>
import { SET_CONFIRM_ORDER_DATA } from "@/core/services/store/shipping_wms.module";
export default {
  name: "ConfirmShippingModal",
  props: ["refresher", "pageLoader", "confirmShipping"],
  data: () => ({
    dialog: false,
  }),
  methods: {
    toggleModal() {
      if (this.dialog) {
        this.$store.commit(SET_CONFIRM_ORDER_DATA, {});
      }
      this.dialog = !this.dialog;
    },
    secondText() {
      return "second-text";
    },
  },
  computed: {
    orderDetails: function () {
      return this.$store.getters.getWMSSHIPPINGConfirmOrderData;
    },
    headers: function () {
      return [
        {
          text: "Box number",
          value: "box_no",
          align: "center",
          class: "text-muted fw-bolder text-uppercase poppins-ls",
          cellClass: "text-dark-75 font-weight-medium poppins-ls",
        },
        {
          text: "Number of SKUS",
          value: "no_of_skus",
          align: "center",
          class: "text-muted fw-bolder text-uppercase poppins-ls",
          cellClass: "text-dark-75 font-weight-medium poppins-ls",
        },
        {
          text: "Total SKU Quantities",
          value: "total_sku_quantites",
          align: "center",
          class: "text-muted fw-bolder text-uppercase poppins-ls",
          cellClass: "text-dark-75 font-weight-medium poppins-ls",
        },
        {
          text: "Description",
          value: "description",
          align: "center",
          class: "text-muted fw-bolder text-uppercase poppins-ls",
          cellClass: "text-dark-75 font-weight-medium poppins-ls",
        },
      ];
    },
  },
};
</script>
